module.exports = __webpack_public_path__ + "img/banner.9cc41c35.png";